export enum SubmenuPapelZero {
  IDENTIFICACAO_PAGINAS = 'IDENTIFICACAO_PAGINAS',
  IDENTIFICADAS = 'IDENTIFICADAS',
}
